<template>
  <div class="container overflow-auto" style="max-height: 70vh;">
    <span v-show='loading'>
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </span>
    <div class="position-relative">
        <div class="position-absolute top-0 end-0">
                <button class="btn btn-info btn-sm" v-if="!expand" @click="collapse" >Collapse All</button> 
                <button class="btn btn-info btn-sm" v-if="expand" @click="expandbtn">Expand All</button> 
            </div>

    </div>
    <div class="d-flex flex-column fs-7 ">  
        
        <div class="d-flex flex-row flex-fill p-1">
            <div class="CanClick d-flex flex-row"  @click="changeInvQuery()" >
                <span class="StockCodeText small ">
                    {{InvQuery.StockCode}}
                </span>
                <span class="DescriptionText small pl-1">{{InvQuery.Description}}</span> 
            </div>      
            <span class="MediaIcon flex-shrink-1 small" v-if="InvQuery.ObjectText!=null">
                <MediaIconVue :MediaObject="InvQuery"></MediaIconVue>
            </span>
        </div>
        <div class="ml-2 border-left">
            <TreeStockCodeVue v-for="b in Bom"  :Bom="b" :key="b.Component" :Level="0"></TreeStockCodeVue> 
        </div>
        <div class="p-2">

        </div>       
    </div>
  </div>
</template>

<script>
 
import {BaseDataService} from '../../../services/BaseData.service';
import MediaIconVue from './MediaIcon.vue'
import TreeStockCodeVue from './TreeStockCode.vue';
const allBom1 = function(bom){
    for(let x = 0;x<bom;x++){
        bom[x].isCheck=!this.expand;
        if(bom[x].Bom && bom[x].Bom.length>0){
            bom[x].Bom=allBom(bom[x].Bom)
        }
    }
    return bom;
}
const allBom = function(bom){
    for(let x = 0;x<bom;x++){   
        bom[x].isCheck=!this.expand;
        if(bom[x].Bom && bom[x].Bom.length>0){
            bom[x].Bom=allBom1(bom[x].Bom)
        }
    }
    return bom;
}
export default {
    
    props: { StockCode: String,Route:String},
    data: () => ({
        loading:true,
        Bom:[],
        InvQuery:{},
        expand:true
    }),
    components:{
        TreeStockCodeVue,
        MediaIconVue
    },
    watch:{
        StockCode(){
            this.loadParent();
        }
    },

    mounted(){
        this.loading = false;
        this.loadParent();
    },
    methods: { 
        loadParent(){
            if(this.StockCode &&this.StockCode!="" ){
                this.loading = true;
                
                BaseDataService.getBom(this.StockCode,this.Route).then(x=>{
                    this.expand=true;
                    this.Bom=x.data.map(x=>{
                        x.isCheck=!this.expand;
                        x.Bom = allBom(x.Bom)
                        return x;
                    });
                    this.loading = false;
                    this.$store.commit("bomStockCode/setSelectSockCode",this.StockCode)
                });
                BaseDataService.getMedia(this.StockCode).then(y=>{
                    this.InvQuery = y.data;
                });
            }
        } ,
        changeInvQuery(){
            this.$store.commit("bomStockCode/setSelectSockCode",this.StockCode)
        },
        collapse(){
            this.expand=!this.expand;
            this.Bom=this.Bom.map(x=>{
                        x.isCheck=!this.expand;
                        x.Bom = allBom(x.Bom)
                        return x;
                    });
        },
        expandbtn(){
            this.expand=!this.expand;
            this.Bom=this.Bom.map(x=>{
                        x.isCheck=!this.expand;
                        x.Bom = allBom(x.Bom)
                        return x;
                    });
        }
    }
  }

</script>

<style>
.pl-1{
    padding-left: 5px;
}
.CanClick{
    cursor: pointer;
}
.ml-2{
    margin-left: 15px;
}
.border-left{
    border-left-style: dashed;
    border-left-width: 1px;
}
.fs-7{
    font-size: 0.8rem !important;
}
</style>